import React from "react";
import { Form, Icon, Input, Checkbox, Radio, Select } from "antd";

import PatientElectronicText from "./Texts/PatientElectronicText";
import SurrogateElectronicText from "./Texts/SurrogateElectronicText";
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class ConsentLhsStep3aPatient extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    const showForEmail = !(props.consentMethodType === "Email" && !props.token);
    const isEmail = props.consentMethodType === "Email";
    const isPatient = props.consentPersonType === "Patient";
    const isEmergency = props.consentPersonType === "Emergency";
    const isSurrogate = props.consentPersonType === "Surrogate";
    const isSubjectFirst = props.email_consent_signature_order === "subject_first";
    const isInvestigatorFirst = props.email_consent_signature_order === "investigator_first";
    const isEmailParticipant = props.signature_type === "participant";
    const isEmailInvestigator = props.signature_type === "investigator";

    return (
      <div className="form-group">
        <h4>
          {props.signature_type === "investigator"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Investigator"
              )
            : props.consentPersonType === "Surrogate"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Surrogate"
              )
            : props.consentPersonType === "Patient"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Patient"
              )
            : props.consentPersonType === "Emergency"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Emergency"
              )
            : ""}
        </h4>

        <div className="form-group-details">
          {props.siteID && (
            <h5>
              {this.props.i18n.t("Site ID")}: <b>{props.siteID}</b>
            </h5>
          )}
          {props.userID && (
            <h5>
              {this.props.i18n.t("User ID")}: <b>{props.userID}</b>
            </h5>
          )}
          <h5>
            {this.props.i18n.t("Subject ID")}: <b>{props.subjectID}</b>
          </h5>
        </div>

        {props.consentPersonType === "Surrogate" ? (
          <SurrogateElectronicText {...props} />
        ) : (
          <PatientElectronicText {...props} />
        )}

        <p>
          <strong>
            {this.props.i18n.t("Server Date (UTC)")}:{" "}
            {props.date || props.consentDate}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("Consent Type")}: {props.consentPersonType}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("Consent Method")}: {props.consentMethodType}
          </strong>
        </p>
        <p>&nbsp;</p>

        <h4>
          {this.props.i18n.t(
            "NamespaceConsentLhsStep3aPatient:DOCUMENTATION OF INFORMED CONSENT"
          )}
        </h4>

        <div style={{ textAlign: "left" }}>
          {showForEmail && !isEmergency && (
            <div>
              <h5 className="headline">HOW DO I INDICATE MY AGREEMENT TO PARTICIPATE?</h5>
              <p>
                Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to take part in the study. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities.
              </p>
              <br/>
              <br/>
              {/*<Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Please check the appropriate box to indicate your decision"
                    )}
                    :
                  </div>
                  {props.form.getFieldDecorator("consent_option", {
                    initialValue: props.consent_option,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  })(
                    <Radio.Group
                      disabled={props.signature_type === "investigator"}
                    >
                      <Radio value="stay_in_study">
                        {this.props.i18n.t(
                          "NamespaceConsentLhsStep3aPatient:I wish to stay in the study."
                        )}
                      </Radio>
                      <br />
                      <Radio value="withdraw_from_study">
                        {this.props.i18n.t(
                          "NamespaceConsentLhsStep3aPatient:I wish to withdraw from the study"
                        )}
                      </Radio>
                      <br />
                      <Radio value="withdraw_from_study_allow_data_collection_via_linkage">
                        {this.props.i18n.t(
                          "NamespaceConsentLhsStep3aPatient:I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage."
                        )}
                      </Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>*/}

              <Form.Item>
                <label>
                  <div className='form-label'>{isSurrogate ? this.props.i18n.t('NamespaceConsentLhsStep3aPatient:CONSENT TO CONTACT IF RESEARCHERS DISCOVER SOMETHING ABOUT YOUR FAMILY MEMBER:') : this.props.i18n.t('NamespaceConsentLhsStep3aPatient:CONSENT TO CONTACT YOU IF RESEARCHERS DISCOVER SOMETHING ABOUT YOU:')}</div>
                  {props.form.getFieldDecorator('consent_question_researchers_share_findings_with_me', {
                    initialValue: props.consent_question_researchers_share_findings_with_me,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Radio.Group disabled={props.signature_type === "investigator"}>
                      <Radio value={true}>
                        Yes, I consent for the researchers to share findings with me.
                      </Radio>
                      <br/>
                      <Radio value={false}>
                        No, I do not consent for the researchers to share findings with me.
                      </Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>

              <Form.Item>
                <label>
                  <div className='form-label'>CONSENT TO USE OF DATA AND SPECIMENS FOR FUTURE RESEARCH:</div>
                  {props.form.getFieldDecorator('consent_question_use_my_research_data', {
                    initialValue: props.consent_question_use_my_research_data,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Radio.Group disabled={props.signature_type === "investigator"}>
                      <Radio value={true}>
                        Yes, I consent to the use of research data and /or specimens for future research.
                      </Radio>
                      <br/>
                      <Radio value={false}>
                        No, I do not consent to the use of research data and /or specimens for future research.
                      </Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>

              <Form.Item>
                <label>
                  <div className='form-label'>CONSENT TO CONTACT YOU FOR FUTURE RESEARCH/INFORMATION:</div>
                  {/*<div style={{ margin: '0 0 5px' }}>
                    My research data may be kept for use in future research to learn about, prevent or treat other health-related problems.
                    <br/>
                    Additional blood/urine may be taken for this research, as described in the consent form.
                  </div>*/}
                  {props.form.getFieldDecorator('consent_question_future_contact', {
                    initialValue: props.consent_question_future_contact,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Radio.Group disabled={props.signature_type === "investigator"}>
                      <Radio value={true}>
                        Yes, I consent to be contacted in the future.
                      </Radio>
                      <br/>
                      <Radio value={false}>
                        No, I do not consent to be contacted in the future.
                      </Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>

              <Form.Item>
                <label>
                  <div className='form-label'>{isSurrogate ? "CONSENT TO CONTACT YOUR FAMILY MEMBER'S DOCTOR" : 'CONSENT TO CONTACT YOUR FAMILY DOCTOR'}:</div>
                  {props.form.getFieldDecorator('consent_question_contact_my_family_doctor', {
                    initialValue: props.consent_question_contact_my_family_doctor,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Radio.Group disabled={props.signature_type === "investigator"}>
                      <Radio value={true}>
                        Yes, I consent for the family doctor to be informed of the participation.
                      </Radio>
                      <br/>
                      <Radio value={false}>
                        No, I do not consent for the family doctor to be informed of the participation.
                      </Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>
            </div>
          )}
          <br />
          <br />

          <Form.Item>
            <label>
              <div className="form-label">
                {this.props.i18n.t("Name of Participant")}
              </div>
              {props.form.getFieldDecorator("consent_subject_full_name", {
                initialValue: props.consent_subject_full_name,
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
              })(
                <Input
                  prefix={<Icon type="user" style={{ color: "#000" }} />}
                  placeholder={this.props.i18n.t("Name of Participant")}
                />
              )}
            </label>
          </Form.Item>

          {!isEmail && <div>
            <Form.Item>
              {props.form.getFieldDecorator("email_consent_copy_to_subject", {
                initialValue: false,
                valuePropName: "checked",
              })(
                <Checkbox>
                  {this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Send copy of consent via email"
                  )}
                </Checkbox>
              )}
            </Form.Item>

            {props.form.getFieldValue("email_consent_copy_to_subject") && <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Patient Email"
                    )}
                  </div>
                  {props.form.getFieldDecorator("consent_subject_email", {
                    initialValue: props.consent_subject_email,
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t(
                          "NamespaceConsentLhsStep3aPatient:Please enter the participant's email"
                        ),
                      },
                      { type: "email" },
                    ],
                  })(
                    <Input
                      disabled={props.token}
                      placeholder={this.props.i18n.t("email")}
                    />
                  )}
                </label>
              </Form.Item>
            </div>}
          </div>}

          {isEmail && isSurrogate && (
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Substitute Decision Maker Email"
                  )}
                </div>
                {props.form.getFieldDecorator("consent_subject_email", {
                  initialValue: props.consent_subject_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsentLhsStep3aPatient:Please enter the participant's email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("email")}
                  />
                )}
              </label>
            </Form.Item>
          )}
          {isEmail && isPatient && (
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t("Participant Email")}
                </div>
                {props.form.getFieldDecorator("consent_subject_email", {
                  initialValue: props.consent_subject_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsentLhsStep3aPatient:Please enter the participant's email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("email")}
                  />
                )}
              </label>
            </Form.Item>
          )}

          {isPatient && (!isEmail || props.signature_type === "participant") && (
              <div>
                <Signature
                  fieldName="consent_subject_signature"
                  label={this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Signature of Participant"
                  )}
                  form={props.form}
                />
              </div>
            )}

          {props.consentPersonType === "Surrogate" && (
            <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Name of Surrogate"
                    )}
                  </div>
                  {props.form.getFieldDecorator("consent_surrogate_full_name", {
                    initialValue: props.consent_surrogate_full_name,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  })(
                    <Input
                      disabled={props.signature_type === "investigator"}
                      prefix={<Icon type="user" style={{ color: "#000" }} />}
                      placeholder={this.props.i18n.t(
                        "NamespaceConsentLhsStep3aPatient:Name of Surrogate"
                      )}
                    />
                  )}
                </label>
              </Form.Item>


              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Relationship to Participant"
                    )}
                  </div>
                  {props.form.getFieldDecorator(
                    "consent_surrogate_relationship",
                    {
                      initialValue: props.consent_surrogate_relationship,
                    }
                  )(
                    <Input
                      disabled={props.signature_type === "investigator"}
                      placeholder={this.props.i18n.t(
                        "NamespaceConsentLhsStep3aPatient:Relationship to Participant"
                      )}
                    />
                  )}
                </label>
              </Form.Item>

              {(!isEmail || props.signature_type === "participant") && (
                <Signature
                  fieldName="consent_surrogate_signature"
                  label={this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Signature of Surrogate"
                  )}
                  form={props.form}
                />
              )}
            </div>
          )}

          {props.signature_type === "investigator" && props.consent_subject_signature && isPatient && <img src={props.consent_subject_signature} width={250} alt='Subject Signature' />}
          {props.signature_type === "investigator" && props.consent_surrogate_signature && isSurrogate && <img src={props.consent_surrogate_signature} width={250} alt='Subject Signature' />}

          <div>
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Name of Person Obtaining Consent"
                  )}
                </div>
                {props.form.getFieldDecorator(
                  "consent_investigator_full_name",
                  {
                    initialValue: props.consent_investigator_full_name,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  }
                )(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{ color: "#000" }} />}
                    placeholder={this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Name of Investigator (print)"
                    )}
                  />
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Person Obtaining Consent Contact Number"
                  )}
                </div>
                {props.form.getFieldDecorator(
                  "consent_investigator_contact_number",
                  {
                    initialValue: props.consent_investigator_contact_number,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  }
                )(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Person obtaining consent contact number"
                    )}
                  />
                )}
              </label>
            </Form.Item>

            {isEmail && isSubjectFirst && !props.signature_type && (
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t("Person Obtaining Consent Email")}
                  </div>
                  {props.form.getFieldDecorator("consent_investigator_email", {
                    initialValue: props.consent_investigator_email,
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t(
                          "NamespaceConsentLhsStep3aPatient:Person Obtaining Consent Email"
                        ),
                      },
                      { type: "email" },
                    ],
                  })(
                    <Input
                      disabled={props.token}
                      placeholder={this.props.i18n.t("email")}
                    />
                  )}
                </label>
              </Form.Item>
            )}

            {(!isEmail ? true : (isSubjectFirst ? props.signature_type === "investigator" : !props.token)) && (
              <Signature
                fieldName="consent_investigator_signature"
                label={this.props.i18n.t(
                  "NamespaceConsentLhsStep3aPatient:Signature of Person Obtaining Consent"
                )}
                form={props.form}
              />
            )}
          </div>

          {!isEmail && (
            <div>
              {/*<p>
                {this.props.i18n.t(
                  "NamespaceConsentLhsStep3aPatient:The following attestation must be provided if the participant is unable to read or requires an oral translation"
                )}
                :
              </p>
              <p>
                <b>
                  {this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:If the participant is assisted during the consent process, please check the relevant box and complete the signature space below"
                  )}
                  :
                </b>
              </p>

              {!isEmail && (
                <Form.Item>
                  {props.form.getFieldDecorator(
                    "consent_interpreter_was_read",
                    {
                      initialValue: false,
                      valuePropName: "checked",
                      rules: [
                        {
                          required: false,
                          transform: (value) => value || undefined,
                          type: "boolean",
                          message: "Required",
                        },
                      ],
                    }
                  )(
                    <Checkbox>
                      {this.props.i18n.t(
                        "NamespaceConsentLhsStep3aPatient:The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered."
                      )}
                    </Checkbox>
                  )}
                </Form.Item>
              )}*/}

              {/*props.form.getFieldValue("consent_interpreter_was_read")*/}

              {!isEmail && (
                  <div>
                    <Form.Item>
                      <label>
                        <div className="form-label">
                          {this.props.i18n.t(
                            "NamespaceConsentLhsStep3aPatient:Witness Name (if applicable)"
                          )}
                        </div>
                        {props.form.getFieldDecorator(
                          "consent_witness_full_name",
                          {
                            initialValue: props.consent_witness_full_name,
                          }
                        )(
                          <Input
                            prefix={
                              <Icon type="user" style={{ color: "#000" }} />
                            }
                            placeholder={this.props.i18n.t(
                              "NamespaceConsentLhsStep3aPatient:Witness Name (if applicable)"
                            )}
                          />
                        )}
                      </label>
                    </Form.Item>

                    <Signature
                      fieldName="consent_witness_signature"
                      label="Signature of Witness (if applicable)"
                      form={props.form}
                      optional={true}
                    />
                  </div>
                )}
            </div>
          )}

          <Form.Item>
            <label>
              <div className="form-label">
                {this.props.i18n.t(
                  "NamespaceConsentLhsStep3aPatient:Has the consent form been completed by all parties?"
                )}
              </div>
              {props.form.getFieldDecorator("consent_provided", {
                initialValue: props.consent_provided,
                rules: [
                  {
                    required: true,
                    message: this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Has the consent form been completed by all parties?"
                    ),
                  },
                ],
              })(
                <Select>
                  <Option value="yes">{this.props.i18n.t("Yes")}</Option>
                  <Option value="">{this.props.i18n.t("No")}</Option>
                </Select>
              )}
            </label>
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(ConsentLhsStep3aPatient);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLhs/ConsentLhsStep3aPatient.js